import React, { useCallback, useRef, useState } from 'react';
import styled from 'styled-components';
import { EditTableConfig, InsertTableConfig, TableColorsConfig, TableFormatStore, TableStylesConfig } from './parts';
import { IEditorToolbarActionBaseProps } from '../types';
import { CommandButton } from '../command-button';
import { Callout } from '../../../../callout';
import { StackPanel } from '../../../../stack-panel';
import { Typography } from '../../../../typography';
import { selectThemeSemantics } from '../../../../../styling';
import { Collapsible, CollapsibleItem } from '../../../../collapsible';

const StyledCallout = styled(Callout)`
    width: 420px;
`;

const StyledStackPanel = styled(StackPanel)`
    padding: ${selectThemeSemantics(({ gap }) => gap.l)};
`;

const StyledCollapsible = styled(Collapsible)`
    height: auto;

    .ap-collapsible-itemContent {
        padding-top: 0;
        margin-top: 2px;
    }
`;

export function InsertTableAction(props: IEditorToolbarActionBaseProps) {
    const itemRef = useRef<HTMLSpanElement>(null);
    const [isCalloutHidden, setCalloutHiddenStatus] = useState(true);

    const showCallout = useCallback(() => {
        setCalloutHiddenStatus(false);
    }, []);

    const hideCallout = useCallback(() => {
        setCalloutHiddenStatus(true);
    }, []);

    return (
        <TableFormatStore>
            <CommandButton {...props} tooltip="Table" iconName="ap-table.rte" elementRef={itemRef} onClick={showCallout} />
            <StyledCallout offset={-5} hidden={isCalloutHidden} isBeakVisible targetRef={itemRef} onDismiss={hideCallout}>
                <StyledStackPanel orientation="vertical" gap="12">
                    <Typography.H5>Insert Table</Typography.H5>
                    <InsertTableConfig onInsert={hideCallout} />
                </StyledStackPanel>
                <StyledCollapsible accordion>
                    <CollapsibleItem id="edit-table" header="Edit Table">
                        <EditTableConfig onInsert={hideCallout} />
                    </CollapsibleItem>
                    <CollapsibleItem id="table-style" header="Predefined Style">
                        <TableStylesConfig onApply={hideCallout} />
                    </CollapsibleItem>
                    <CollapsibleItem id="customize-colors" header="Customize Colors">
                        <TableColorsConfig onApply={hideCallout} />
                    </CollapsibleItem>
                </StyledCollapsible>
            </StyledCallout>
        </TableFormatStore>
    );
}
